import axios from 'axios'

export default {
    getList(data, fields) {
        const _fields = (
            fields || [
                'id',
                'firstName',
                'lastName',
                'middleName',
                'suffix',
                'title',
                'phone',
                'email',
                'address',
                'city',
                'state',
                'zip',
                'specialities(speciality(id,name),subSpeciality(id,name))',
            ]
        ).join(',')

        return axios.get(`/unauthenticated/physician-records`, {
            params: { _fields, ...data },
        })
    },
}
